<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>物料着陆页信息维护</span>
      </div>
      <el-form
        ref="materialForm"
        :model="materialInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <div class="add-form-item">
          <el-form-item label="物料编码：" prop="materialCode">
            <el-input v-model="materialInfo.materialCode"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多不超过20个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="物料型号：" prop="materialDesc">
            <el-input v-model="materialInfo.materialDesc"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多不超过20个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="跳转地址：" prop="materialUrl">
            <el-input v-model="materialInfo.materialUrl"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多不超过450个字符</span>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      roleOptions: [],
      materialInfo: {
        materialId: "",
        materialCode: "",
        materialDesc: "",
        materialUrl: ""
      },
      rules: {
        materialCode: [
          {
            max: 20,
            message: "最多输入20个字符",
            trigger: "change"
          }
        ],
        materialDesc: [
          {
            max: 20,
            message: "最多输入20个字符",
            trigger: "change"
          }
        ],
        materialUrl: [
          {
            max: 450,
            message: "最多输入450个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getMaterialById: function(id) {
      let _this = this;
      let param = {
        url: "/api/material/getMaterialInfoById",
        params: {
          materialId: id
        }
      };

      _this.$store.dispatch("getMaterialInfo", param).then(() => {
        _this.materialInfo =
          _this.$store.state.material.materialData.materialInfo;
      });
    },
    submit() {
      let _this = this;
      _this.$refs.materialForm.validate(isPass => {
        if (isPass) {
          let param = {
            url: "/api/material/updateMaterialInfo",
            params: {
              materialId: _this.materialInfo.materialId,
              materialCode: _this.materialInfo.materialCode,
              materialDesc: _this.materialInfo.materialDesc,
              materialUrl: _this.materialInfo.materialUrl
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "物料着陆页信息维护成功",
                  type: "success"
                });
                this.$router.push({
                  name: "materialIndex"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善物料着陆页信息!",
            type: "warning"
          });
        }
      });
    }
  },
  created() {
    let _this = this;
    let id = this.$route.params.materialId;
    if (id !== null && id !== "" && id !== undefined) {
      _this.getMaterialById(id);
    }
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
